import routeImportScheme from './route-import-scheme';
import routeMetadata from './route-metadata';

const withContext = routePath => {
  if (!routePath) return '/:context?';
  return `/:context${routePath.startsWith('/') ? '' : '/'}${routePath}`;
};

// Merge the route component import scheme with the route metadata and return a
// consolidated route map of all the child routes below the parent route
const routes = routeMetadata.map(item => {
  const routeScheme = routeImportScheme[item.path] || routeImportScheme.base;
  return {
    ...item,
    ...routeScheme,
    path: withContext(item.path),
  };
});

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.unshift({
    // TODO: This route is broken, it gets asserted as an account context.
    path: '/error',
    load: () => import('./error'),
  });
}

export default routes;
